export default "__VITE_ASSET__CxrfGypI__"